export const DISPLAY_MODAL = "DISPLAY_MODAL"
export const TRIGGER_RESULT_RESET = "TRIGGER_RESULT_RESET"
export const OPEN_SHARE_MODAL = "OPEN_SHARE_MODAL"
export const OPEN_FILE_MODAL = "OPEN_FILE_MODAL"
export const OPEN_EMBED_MODAL = "OPEN_EMBED_MODAL"
